import { useRouter, } from 'next/router';


export default function useDarkModeChecker() {
  const router = useRouter();
  return router?.query?.isDarkMode === true;
}
